import { useTranslation } from 'react-i18next';
import { Select } from '@/components/ui/Select';
import { usePosSession } from '@/hooks/usePosSession';
import { useAppSelector } from '@/hooks/useAppSelector';

export function PosCounterPicker() {
  const { t } = useTranslation('pos');
  const store = useAppSelector((s) => s.app.selectedStore);
  const { counters, counterId, setCounterId, loading, selectedCounter, activeShiftId } = usePosSession();

  if (!store || loading) return null;

  if (counters.length === 0) {
    return (
      <span className="text-xs text-amber-600 dark:text-amber-400">
        No counters — configure in Setup
      </span>
    );
  }

  return (
    <label className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
      <span className="hidden sm:inline">Counter</span>
      <Select
        className="min-w-[10rem]"
        placeholder={t('labels.selectCounter')}
        value={counterId != null ? String(counterId) : ''}
        onChange={(v) => setCounterId(v ? Number(v) : undefined)}
        options={counters.map((c) => ({
          value: String(c.id),
          label: `${c.name} (${c.code})`,
        }))}
      />
      {selectedCounter?.currentShiftId != null || activeShiftId ? (
        <span className="text-xs text-emerald-600">Shift open</span>
      ) : (
        <span className="text-xs text-amber-600">No shift</span>
      )}
    </label>
  );
}
